import { render, staticRenderFns } from "./index.vue?vue&type=template&id=cd2d8c50&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\project\\文化宫\\code\\whg\\Web\\Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cd2d8c50')) {
      api.createRecord('cd2d8c50', component.options)
    } else {
      api.reload('cd2d8c50', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=cd2d8c50&", function () {
      api.rerender('cd2d8c50', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PMS/customerService/complaintManage/index.vue"
export default component.exports